import { CustomSetFilterComponent } from '@shared/components/grid-components/custom-set-filter/custom-set-filter.component';
import { WatchlistProject } from '../models/watchlist-project.model';
import { customSetFilterDoesFilterPass } from '@shared/utils/set-filter.utils';
import { getCellClass } from '../watchlists-table/watchlists-table.config';
import { ITextFilterParams, type ColDef } from 'ag-grid-community';
import { stringNullComparator } from '@shared/utils/comparator.util';

export const projectColDefs: ColDef[] = [
  {
    field: 'projectName',
    filter: 'agTextColumnFilter',
    filterParams: {
      buttons: ['reset'],
      maxNumConditions: 1,
    } as ITextFilterParams,
  },
  {
    field: 'projectCountry',
    filter: 'agTextColumnFilter',
    filterParams: {
      buttons: ['reset'],
    } as ITextFilterParams,
    headerName: 'Risk Location',
  },

  {
    field: 'projectCompany',

    filter: 'agTextColumnFilter',
    filterParams: {
      buttons: ['reset'],
    } as ITextFilterParams,
    headerName: 'Company Names',
    comparator: stringNullComparator,
  },
  {
    field: 'sensitivityName',
    filter: { component: CustomSetFilterComponent<WatchlistProject>, doesFilterPass: customSetFilterDoesFilterPass },
    filterParams: {
      // Preselected values that should be selected by default
      preselectedValues: ['High Risk', 'Abstain'],
    },
    maxWidth: 150,
    headerName: 'Risk Score',
    cellClass: p => getCellClass(p.value),
  },
  {
    field: 'updatedDate',
    filter: 'agDateColumnFilter',
    filterParams: {
      buttons: ['reset'],
      maxNumConditions: 1,
    },
    maxWidth: 150,
    headerName: 'Last Reviewed',
  },
  {
    field: 'activeFrom',
    filter: 'agDateColumnFilter',
    filterParams: {
      buttons: ['reset'],
      maxNumConditions: 1,
    },
    maxWidth: 150,
    headerName: 'Valid From',
  },
];
